var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackingBookVisit } from "@/hooks/tracking/useTrackingBookVisit";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { CalendarIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
export const BookVisitButton = (_a) => {
    var { rootTestId, children, iconOnly = false, variant = "secondary", av_zone } = _a, props = __rest(_a, ["rootTestId", "children", "iconOnly", "variant", "av_zone"]);
    const isPreviewMode = useIsPreviewMode();
    const trackBookVisitClick = useTrackingBookVisit(av_zone);
    return (
    // @ts-ignore
    _jsx(Button, Object.assign({ size: iconOnly ? "40" : undefined, iconOnly: iconOnly }, props, { testId: `${rootTestId}.BookVisit`, variant: variant, icon: CalendarIcon, iconPosition: "start", isFullWidth: true, onPress: () => {
            var _a;
            trackBookVisitClick();
            // eslint-disable-next-line no-restricted-globals
            (_a = window.$plato) === null || _a === void 0 ? void 0 : _a.open();
        }, isDisabled: isPreviewMode, children: children })));
};
